<template>
  <div class="list-vendors">
    <PageHeader title="Vendors" :action="{ title: 'Add Vendor', to: { name: 'CreateVendor' } }" />

    <BaseTable
      :is-loading="isPending"
      :items="results"
      :fields="tableFields"
      :is-searchable="true"
      :clickable="true"
      :paginate="true"
      :error="error"
      :next-page="nextPage"
      :prev-page="prevPage"
      :page="currentPage"
      :total-records="totalRecords"
      :total-pages="totalPages"
      :number-per-page="numPerPage"
      @on-search="(val) => search(val)"
      @row-selected="onRowSelected"
    >
      <template #logo-data="data">
        <BaseAvatar v-if="data.row.logo" :image="data.row.logo" class="size-10" />
        <BaseAvatar v-else class="size-10" />
      </template>
      <template #name-data="data">
        <span class="font-semibold text-slate-950">{{  data.row.name }}</span>
      </template>
    </BaseTable>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import VendorService from '@/services/VendorService'
import PageHeader from '@/components/app/AppPageHeader.vue'
import BaseTable from '@/components/base/BaseTable.vue'
import BaseAvatar from '@/components/base/BaseAvatar.vue'
import { useSearchablePagination } from '@/composables/useSearchablePagination'

const tableFields = [
  { key: 'logo', label: ''},
  { key: 'name', label: 'Name', sortable: true },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
]

const numPerPage = ref(25)

const {
  results,
  isPending,
  error,
  search,
  currentPage,
  totalPages,
  totalRecords,
  nextPage,
  prevPage,
} = useSearchablePagination({
  indexName: 'vendors',
  service: new VendorService(),
  numPerPage: numPerPage.value,
  defaultOrderBy: 'name',
  defaultOrderDir: 'asc'
})

const $router = useRouter()
const onRowSelected = (row: any) => {
  $router.push({ name: 'ShowVendor', params: { id: row.id } })
}

</script>
